import React, { ReactNode } from 'react';

import { Cell, Label, Value } from './DataCard.styled';

interface IProps {
  label?: string;
  value?: ReactNode;
  highlighted?: boolean;
}

export const DataCardCell = ({ label, value, highlighted }: IProps) => {
  return (
    <Cell $highlighted={highlighted}>
      {label && <Label>{label}</Label>}
      {value != null && value !== '' && <Value>{value}</Value>}
    </Cell>
  );
};
